import { StatusFormatterVariant } from '@components'

import { QuoteListFilter } from '../../../enums/quoteListFilter'
import { QuoteRowStatus } from '../types/quoteRowStatus'

/**
 * Mirrors the quote summary filter cards (`quoteListFilterToBadgeColor`) so the
 * quote status colours stay consistent with the cards above the list. `primary`
 * is the StatusFormatter equivalent of the Badge `accent` color, and `error` of
 * the Badge `danger` color.
 */
export const quoteRowStatusToStatusFormatterVariant: Record<QuoteRowStatus, StatusFormatterVariant> = {
  [QuoteListFilter.Draft]: 'neutral',
  [QuoteListFilter.Pending]: 'warning',
  [QuoteListFilter.Rejected]: 'error',
  [QuoteListFilter.Accepted]: 'success',
  [QuoteListFilter.Invoiced]: 'primary',
}
